import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import {useTranslation} from 'react-i18next';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const SkillStatChart = (props) => {
    const {labels, data} = props.values;

    const options = {
        scale: {
            beginAtZero: true,
            min: 0,
            max: 10,
            step: 2
        },

        plugins: {
            legend: {
                display: false
            }
        }
    };

    const chartData = {
        labels: labels,
        datasets: [
            {
                data: data,
                backgroundColor: 'rgba(255, 99, 132, 0.2)',
                borderColor: 'rgba(255, 99, 132, 1)',
                borderWidth: 1,
            },
        ],
    };

    return (
        <Bar options={options} data={chartData} />
    );
};

SkillStatChart.defaultProps = {};

export default SkillStatChart;
